import { CachedEventRegistry } from './events/cached_event_registry';
import { Farm as Site } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/farmSchema';

/**
 * @Deprecated This is terrible. Use `useSite()` instead.
 */
export class SiteStateService {
    private _site: Site | null;
    private _siteSelectionChangedEventRegistry: CachedEventRegistry;

    constructor() {
        this._site = null; // the service is created before we load any sites
        this._siteSelectionChangedEventRegistry = new CachedEventRegistry();
    }

    public onSiteSelectionChanged(
        callback: (siteStateService: SiteStateService) => any,
    ): () => void {
        return this._siteSelectionChangedEventRegistry.addEventListener(callback);
    }

    get site(): Site {
        if (!this._site) throw Error("we don't have a site yet");
        return this._site;
    }

    set site(site: Site) {
        this._site = site;
        void this._siteSelectionChangedEventRegistry.notifyListeners(this);
    }

    /**
     * @Deprecated This is broken as hell. Use `site.id` from `useSite` instead.
     */
    get selectedSiteId(): number {
        return Number(localStorage.getItem('siteId'));
    }
}
